import { FC } from "react";

import {
  FilterByTextListAppliedFilterView,
  FilterByTextListItem,
} from "@/domain/view/components/datatable/datatable-filters/filter-by-text-list-applied-filter-view.tsx";

import { ALLOWED_INDICATOR_TYPES, IndicatorTypeGermanNames } from "../../../models/indicator-type-model.ts";
import { IndicatorTypeView } from "../../indicator-type-view.tsx";

import { DatatableIndicatorTypeDisplayView } from "./datatable-indicator-type-display-view.tsx";

export interface DatatableIndicatorTypeAppliedFilterViewProps {
  column: {
    id: string;
  };
}

export const DatatableIndicatorTypeAppliedFilterView: FC<DatatableIndicatorTypeAppliedFilterViewProps> = ({
  ...props
}) => {
  const itemList = ALLOWED_INDICATOR_TYPES.map((indicatorType) => ({
    id: indicatorType,
    name: IndicatorTypeGermanNames[indicatorType],
  }));

  const renderItem = (item: FilterByTextListItem | null, view: "icon" | "text" | "icon-text") => {
    const indicatorType = itemList.find((i) => i.name === item?.name) ?? null;

    const showLogo = view === "icon" || view === "icon-text";
    const showText = view === "text" || view === "icon-text";

    return (
      <IndicatorTypeView
        key={item?.id}
        type={indicatorType?.id}
        className="h-3"
        placeholder={"Keine Kategorie"}
        hideLogo={!showLogo}
        hideText={!showText}
      />
    );
  };

  const renderDisplayView = () => {
    return <DatatableIndicatorTypeDisplayView />;
  };

  return (
    <FilterByTextListAppliedFilterView
      column={props.column}
      itemList={itemList}
      renderItem={renderItem}
      renderDisplayView={renderDisplayView}
    />
  );
};
